<template>
  <div>
    <div class="px-1 mt-5 text_s">
      <img
        src="../../assets/info.png"
        alt=""
        style="width: 100%; height: 100%"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {

  },
  data () {
    return {

    };
  },
  components: {

  },
  computed: {

  },
  watch: {

  },
  created () {

  },
  mounted () {

  },
  methods: {

  },
};
</script>

<style scoped lang="less">
.px-1 {
  padding: 0 10px;
}
.text-c {
  text-align: center;
}
.text_s {
  text-align: start;
}
.mt-2 {
  margin-top: 10px;
}
.font-40 {
  font-size: 24px;
}
.font-w {
  font-weight: bold;
}
.mt-5 {
  margin-top: 25px;
}
.font-36 {
  font-size: 18px;
}
</style>
